<template>
  <section class="pack-class">

    <div class="info">
      <h2 class="title">Quer potencializar seus resultados?</h2>
      <h5 class="subtitle">Conheça a consultoria Pack Class.</h5>
      <p class="description">Garantir uma prestação de serviços de qualidade é a chave para toda Empresa Contábil que deseja crescer e reter sua carteira de clientes. O serviço de consultoria faz um levantamento do nível de utilização de nossos sistemas, onde serão verificados os recursos e ferramentas que estão sendo subutilizados ou utilizados de forma inadequada.</p>
    </div>

    <div class="imagem">
      <img
        src="https://www.alterdata.com.br/images/fixo/produtos/packclass/packclass_logo.svg"
        alt="PackClass logo">
    </div>
  </section>
</template>

<script>
export default {
  name: 'PackClass'
}
</script>